import { createContext, useContext, useEffect, useState } from "react";
import { MultiContext } from "../../Context";
import { api } from "../../util";

export const FileContext = createContext();

export default function Files({ className = "" }) {
  const multiCtx = useContext(MultiContext);

  const [files, setFiles] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);

  const [history, setHistory] = useState([]);
  const [selectedCommit, setSelectedCommit] = useState(null);

  const [fileContent, setFileContent] = useState(null);

  const getFileAtCommit = () => {
    api(
      "get_file_at_commit",
      {
        name: multiCtx.currentRepo?.name,
        path: selectedFile?.path,
        abbrevHash: selectedCommit?.abbrev_hash,
      },
      (data) => setFileContent(data.after)
    );
  };

  useEffect(() => {
    multiCtx.getFiles((data) => setFiles(data.files));
  }, [multiCtx.currentRepo]);

  useEffect(() => {
    if (selectedCommit) {
      getFileAtCommit();
    } else {
      setFileContent(null);
    }
  }, [selectedCommit]);

  useEffect(() => {
    if (selectedFile) {
      multiCtx.getHistory(selectedFile?.path, (data) =>
        setHistory(data.history)
      );
    } else {
      setHistory([]);
    }
    setFileContent(null);
    setSelectedCommit(null);
  }, [selectedFile]);

  const contextValue = {
    files: files,
    setFiles: setFiles,
    selectedFile: selectedFile,
    setSelectedFile: setSelectedFile,
  };

  return (
    <FileContext.Provider value={contextValue}>
      <div className={className + " flex h-100"}>
        <div className="col-25">
          {files.map((x) => (
            <div
              onClick={() =>
                setSelectedFile(selectedFile?.path === x.path ? null : x)
              }
              className={
                "file-item between" +
                (selectedFile?.path === x.path ? " active" : "")
              }>
              <div>{x.name}</div>
              <div className="opacity-50 fst-italic small my-auto">
                {x.parentPath !== "." ? x.parentPath : ""}
              </div>
            </div>
          ))}
        </div>
        <div className="divider"></div>
        <div className="col-25">
          {history.map((item) => (
            <div
              className={
                className +
                " log-item" +
                (selectedCommit?.abbrev_hash === item.abbrev_hash
                  ? " active"
                  : "")
              }>
              <div>
                <div className="between mb-1">
                  <div className="fw-bold text-truncate">
                    <a
                      onClick={() =>
                        setSelectedCommit(
                          selectedCommit?.abbrev_hash === item.abbrev_hash
                            ? null
                            : item
                        )
                      }
                      title={item.name}>
                      {item.name}
                    </a>
                  </div>
                  <span className="small font-monospace">
                    {item.abbrev_hash}
                  </span>
                </div>
                <div className="between small fw-light">
                  <span>{item.timestamp}</span>
                  <span>{item.author}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="divider"></div>
        <div className="col-50 d-flex">
          <div className="file-content">{fileContent}</div>
        </div>
      </div>
    </FileContext.Provider>
  );
}
